export default __webpack_public_path__ + "static/Interactive-interface-e5b2eab48024ab9f4ad79204e94f22e0.webp";